import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
  })
  export class HelpFormsService {
  
    private dataSource = new BehaviorSubject(null);
    
    constructor(
      private _http: HttpClient
    ) { }
  
    refreshCount(data: any[]) {
      this.dataSource.next(data);
    }
    
    getHelpForms() {
      let endPoint = `${environment.url}/getHelpForms/${environment.help_form_id}`
      // return this._http.get(environment.url + "/forms/" + organizationId + "/" + actionType + "?from=filecabinet");
      return this._http.get(endPoint)
    }
  
}
  